export default "__VITE_ASSET__CkiDBsPT__"